import React from 'react';
import { CountryProvider, type Country } from '@/contexts/CountryContext';
import AuthModal from './zera/AuthModal';
import Navbar from './zera/Navbar';
import HeroSection from './zera/HeroSection';
import LazyIntroVideo from './zera/LazyIntroVideo';
import DestinationsGrid from './zera/DestinationsGrid';
import ExperiencesSection from './zera/ExperiencesSection';
import ZeraPartners from './zera/ZeraPartners';
import DestinationMap from './zera/DestinationMap';
import PlanJourneyForm from './zera/PlanJourneyForm';
import AboutSection from './zera/AboutSection';
import Footer from './zera/Footer';

const AppLayout: React.FC<{ country?: Country }> = ({ country = 'albania' }) => {
  // Romania re-skins the same markup from navy+gold to maroon+gold via a
  // scoped CSS theme (see `.theme-romania` overrides in index.css).
  const themeClass = country === 'romania' ? 'theme-romania' : 'theme-albania';
  return (
    <CountryProvider country={country}>
      <div className={`${themeClass} min-h-screen bg-[#FAF8F3]`}>
        <Navbar />
        <HeroSection />
        <DestinationsGrid />
        <ExperiencesSection />
        <DestinationMap />
        <PlanJourneyForm />
        <AboutSection />
        <LazyIntroVideo />
        <ZeraPartners />
        <Footer />
      </div>
      <AuthModal />
    </CountryProvider>
  );
};


export default AppLayout;
